import React, { useState } from 'react'
import visa from '../public/images/visa.png'

const Pay = ({HandelSelect,select}) => {
   
  return (
    <div className='section'>
    <div className='d-flex carry align-items-center mt-4 mb-3'>
    <div className='carry-number '><i class="fa-solid fa-2"></i></div>
    <p>الدفع</p>
    </div>  
   <div className='d-flex ' >
      {/* <div className='payment-select' onClick={()=>HandelSelect(1)} style={{ borderColor:select===1&&'goldenrod' }}>
       {select===1&&(
         <div className='circle-check'>
           <i class="fa-solid fa-circle-check"></i>
         </div>
       )}
        <img src={visa} width={50} height={50}/>
      </div> */}
      <div className='payment-select flex-column' onClick={()=>HandelSelect(0)} style={{ borderColor:select===2&&'goldenrod' }}>
      {select===0&&(
         <div className='circle-check'>
            <i class="fa-solid fa-circle-check"></i>
         </div>
       )}
      <i class="fa-solid fa-money-bill-wave"> </i>
      <p>الدفع عند الاستلام</p>
   </div>
   </div>
  </div>  )
}

export default Pay